(function () {
  if (window.__evLpReviewsV2Booted) return;
  if (!document.documentElement.classList.contains('eveloria-turmeric-landing')) return;
  if (!/\/pages\/turmeric-brightening/.test(window.location.pathname)) return;

  window.__evLpReviewsV2Booted = true;

  var TURMERIC_PADS_PRODUCT_ID = '8957783769345';
  var AR_BOX_PRODUCT_ID = '8823250813185';
  var AR_TEMPLATE_SUFFIX = 'kojic-acid-pads-new';
  var AR_PAGE_TYPE = 'product.kojic-acid-pads-new';
  var WIDGET_SELECTOR = '#ev-product-reviews .alireviews-review-box';
  var BOX_SCRIPT_FALLBACK =
    'https://cdn.shopify.com/extensions/019e6d9a-f6b8-7615-a900-dd81f6091887/ali-reviews-264/assets/alireviews-box.min.js';

  function clearArBlockers() {
    try {
      delete window.__AR_VARIABLE_INJECT;
    } catch (e) {
      window.__AR_VARIABLE_INJECT = 0;
    }
    try {
      delete window.__AR_CORE_SNIPPET;
    } catch (e) {
      window.__AR_CORE_SNIPPET = false;
    }
  }

  function patchProductId() {
    clearArBlockers();

    window.Shopify = window.Shopify || {};
    window.Shopify.product = {
      id: Number(TURMERIC_PADS_PRODUCT_ID),
      handle: 'turmeric-pads'
    };

    window.__AR_WIDGET_REVIEW_OBJECT = Object.assign(window.__AR_WIDGET_REVIEW_OBJECT || {}, {
      product_id: TURMERIC_PADS_PRODUCT_ID,
      template_id: 'product',
      template_suffix: AR_TEMPLATE_SUFFIX,
      page_type: AR_PAGE_TYPE
    });

    document.querySelectorAll('.alireviews-review-box').forEach(function (el) {
      el.setAttribute('data-product-id', AR_BOX_PRODUCT_ID);
    });
  }

  function unhideReviewWidget() {
    document
      .querySelectorAll(
        '.alireviews-review-box-body, .alr-wh-comp-summary, .alr-wh-comp-review-listing-wrap, .alr-wh-comp-review-list'
      )
      .forEach(function (el) {
        el.classList.remove('ev-alireviews__review--hidden');
        el.removeAttribute('aria-hidden');
        el.style.removeProperty('display');
      });
  }

  function forceLoadBoxScript() {
    if (document.querySelector('script[src*="alireviews-box"]')) return;

    var path = window.__AR_PUBLIC_PATH;
    var src = BOX_SCRIPT_FALLBACK;
    if (path) {
      if (path.indexOf('http') === 0) {
        src = path + 'alireviews-box.min.js';
      } else if (path.indexOf('//') === 0) {
        src = 'https:' + path + 'alireviews-box.min.js';
      } else {
        src = path + 'alireviews-box.min.js';
      }
    }

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.body.appendChild(script);
  }

  function loadWidget() {
    patchProductId();
    unhideReviewWidget();

    var boxes = document.querySelectorAll(WIDGET_SELECTOR);
    if (!boxes.length) return;

    boxes.forEach(function (box) {
      box.style.display = 'block';
      box.setAttribute('data-product-id', AR_BOX_PRODUCT_ID);
    });

    if (typeof window.__AR_loadJSWidget === 'function') {
      window.__AR_loadJSWidget(WIDGET_SELECTOR, 'alireviews-box.min.js');
    }

    forceLoadBoxScript();
  }

  function widgetLooksReady() {
    var mount = document.getElementById('ev-product-reviews');
    var box = mount && mount.querySelector('.alireviews-review-box');
    var listing = box && box.querySelector('.alr-wh-comp-review-listing-wrap');
    return !!(
      box &&
      box.querySelector('.alr-wh-comp-summary') &&
      listing &&
      listing.offsetHeight > 80
    );
  }

  function findFooterReviewsSection() {
    return document.querySelector('[id*="__product_reviews_footer"]');
  }

  function moveSectionToBottom(section) {
    var main = document.querySelector('main#MainContent, main');
    if (!main || !section) return;
    section.style.setProperty('display', 'block', 'important');
    section.style.visibility = 'visible';
    if (main.lastElementChild !== section) main.appendChild(section);
  }

  function hideLegacyMidPageReviews() {
    document.querySelectorAll('[id*="__product_reviews"]').forEach(function (el) {
      if (el.id.indexOf('__product_reviews_footer') !== -1) return;
      if (el.id === 'ev-lp-reviews-root' || el.closest('#ev-lp-reviews-root')) return;
      el.style.display = 'none';
    });
  }

  function boot() {
    if (window.__evLpReviewsBootStarted) return;
    window.__evLpReviewsBootStarted = true;

    patchProductId();
    hideLegacyMidPageReviews();

    var bootstrapMount = document.getElementById('ev-lp-reviews-root');
    if (bootstrapMount) bootstrapMount.style.display = 'none';

    var footer = findFooterReviewsSection();
    if (footer) moveSectionToBottom(footer);

    var mount = document.getElementById('ev-product-reviews');
    if (mount) {
      var loading = mount.querySelector('.ev-turmeric-reviews__empty');
      if (loading && !mount.querySelector('.alireviews-review-box')) {
        loading.textContent = 'Loading customer reviews…';
      }
    }

    loadWidget();

    var attempts = 0;
    var timer = window.setInterval(function () {
      loadWidget();
      unhideReviewWidget();

      if (mount) {
        var loadingEl = mount.querySelector('.ev-turmeric-reviews__empty');
        if (loadingEl && widgetLooksReady()) loadingEl.remove();
      }

      if (widgetLooksReady() || ++attempts > 100) {
        window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', function () {
    if (!widgetLooksReady()) boot();
  }, { once: true });
})();
